<template>
  <section class="team-section">
    <h2 class="section-title">团队信息</h2>
    <div class="info-card">
      <div class="stats-grid">
        <div
          v-for="(item, index) in statsItems"
          :key="index"
          class="stat-item"
          :style="{ width: index === 0 || index === 4 ? '10%' : '30%' }"
        >
          <span class="stat-value">{{ item.value }}</span>
          <span class="stat-label">{{ item.label }}</span>
        </div>
      </div>

      <div class="divider" />

      <div class="withdraw-rows">
        <div
          v-for="item in withdrawItems"
          :key="item.type"
          class="withdraw-row"
        >
          <p class="withdraw-text">
            已提现<span :class="item.highlightClass">{{ item.highlight }}</span>收益:
            {{ item.value }}
          </p>
          <button
            class="withdraw-btn"
            :class="item.btnClass"
            :disabled="withdrawingType === item.type"
            @click="$emit('withdraw', item.type)"
          >
            {{ withdrawingType === item.type ? "处理中..." : item.btnText }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
    withdrawingType: {
      type: String,
      default: "",
    },
  },
  computed: {
    statsItems() {
      return [
        { value: this.info.depth, label: "直推" },
        { value: this.info.directPerformance, label: "直推业绩" },
        { value: this.info.totalPerformance, label: "总业绩" },
        { value: this.info.promotionReward, label: "推广收益" },
        { value: this.info.totalCards, label: "卡牌" },
        { value: this.info.cardBenefit, label: "卡牌权益" },
        { value: this.info.cardReward, label: "卡牌收益" },
        { value: this.info.claimQuota, label: "总计额度" },
      ];
    },
    withdrawItems() {
      return [
        {
          type: "staking",
          highlight: "质押",
          highlightClass: "pink",
          value: this.info.withdrawnStaking,
          btnText: "提取质押收益",
          btnClass: "pink",
        },
        {
          type: "promotion",
          highlight: "推广",
          highlightClass: "purple",
          value: this.info.withdrawnPromotion,
          btnText: "提取推广收益",
          btnClass: "purple",
        },
        {
          type: "card",
          highlight: "卡牌",
          highlightClass: "orange",
          value: this.info.withdrawnCard,
          btnText: "提取卡牌收益",
          btnClass: "orange",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.team-section {
  padding: 0 30px 40px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 30px;
  color: #fff;
}

.info-card {
  padding: 20px 16px;
  border-radius: 16px;
  background: #040a28;
}

.stats-grid {
  gap: 16px 8px;
  overflow: hidden;
}

.divider {
  margin: 24px 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  float: left;
  margin-bottom: 10px;

  .stat-value {
    margin-bottom: 4px;
    font-size: 26px;
    color: #fff;
    word-break: break-all;
  }

  .stat-label {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.5);
  }
}

.withdraw-rows {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.withdraw-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.withdraw-text {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;

  .pink {
    color: #f34bff;
  }

  .purple {
    color: #7b4bff;
  }

  .orange {
    color: #f5a623;
  }
}

.withdraw-btn {
  flex-shrink: 0;
  min-width: 180px;
  height: 44px;
  padding: 0 16px;
  border: none;
  border-radius: 32px;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;

  &.pink {
    background: #f34bff;
  }

  &.purple {
    background: #7b4bff;
  }

  &.orange {
    background: #f5a623;
  }

  &:hover {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
